import React, { useState } from "react";
import { APP_THEME } from "../theme/theme";
import AppFooter from "../components/app-footer";
import Header from "../components/header";

function Setting() {
    const [darkMode, setDarkMode] = useState(true);
    const [settings, setSettings] = useState({
        push: true,
        email: false,
        sms: true,
        biometric: false,
        twoFactor: false,
        language: "English",
    });

    const isCurrentlyDark = darkMode === true || (darkMode === null && window.matchMedia('(prefers-color-scheme: dark)').matches);

    const toggleSetting = (key) => {
        setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const Toggle = ({ active, onToggle }) => (
        <div
            onClick={onToggle}
            className="w-11 h-6 rounded-xl relative cursor-pointer transition-all duration-250"
            style={{
                background: active ? APP_THEME.primaryColor : "#D1D5DB",
            }}
        >
            <div
                className="w-5 h-5 rounded-full absolute top-0.5 bg-white transition-all duration-250 shadow-sm"
                style={{
                    left: active ? "22px" : "2px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
            />
        </div>
    );

    const Section = ({ title, children }) => (
        <div className="mb-6">
            <h3
                className="text-sm font-semibold mb-3 uppercase tracking-wide"
                style={{
                    color: APP_THEME.primaryColor,
                    fontFamily: APP_THEME.fontFamily,
                    letterSpacing: "0.5px",
                }}
            >
                {title}
            </h3>
            <div
                className="rounded-card border overflow-hidden"
                style={{
                    background: APP_THEME.surfaceColor,
                    borderRadius: APP_THEME.borderRadiusCard,
                    borderColor: APP_THEME.borderColor,
                }}
            >
                {children}
            </div>
        </div>
    );

    const Row = ({ label, children, isLast }) => (
        <div
            className="flex items-center justify-between px-4 py-3.5"
            style={{
                borderBottom: isLast ? "none" : `1px solid ${APP_THEME.borderColor}`,
            }}
        >
            <span
                className="text-sm font-medium"
                style={{
                    color: APP_THEME.textPrimary,
                    fontFamily: APP_THEME.fontFamily,
                }}
            >
                {label}
            </span>
            {children}
        </div>
    );

    return (
        <>
            <Header title={"Setting"} showBack={true} />
            <div className="p-4 pb-20">
                <Section title="Notifications">
                    <Row label="Push Notifications">
                        <Toggle active={settings.push} onToggle={() => toggleSetting("push")} />
                    </Row>
                    <Row label="Email Alerts">
                        <Toggle active={settings.email} onToggle={() => toggleSetting("email")} />
                    </Row>
                    <Row label="SMS Alerts" isLast>
                        <Toggle active={settings.sms} onToggle={() => toggleSetting("sms")} />
                    </Row>
                </Section>

                <Section title="Security">
                    <Row label="Biometric Login">
                        <Toggle active={settings.biometric} onToggle={() => toggleSetting("biometric")} />
                    </Row>
                    <Row label="2-Factor Auth" isLast>
                        <Toggle active={settings.twoFactor} onToggle={() => toggleSetting("twoFactor")} />
                    </Row>
                </Section>

                <Section title="Appearance">
                    <Row label="Dark Mode" isLast>
                        <Toggle active={isCurrentlyDark} onToggle={() => setDarkMode(!isCurrentlyDark)} />
                    </Row>
                </Section>

                <Section title="Account">
                    <Row label="Change Language">
                        <select
                            value={settings.language}
                            onChange={(e) => setSettings((prev) => ({ ...prev, language: e.target.value }))}
                            className="border-none bg-transparent text-sm font-semibold outline-none cursor-pointer"
                            style={{
                                color: APP_THEME.primaryColor,
                                fontFamily: APP_THEME.fontFamily,
                            }}
                        >
                            <option>English</option>
                            <option>Hindi</option>
                            <option>Tamil</option>
                            <option>Telugu</option>
                        </select>
                    </Row>
                    <Row label="App Version" isLast>
                        <span
                            className="text-[13px]"
                            style={{
                                color: APP_THEME.textSecondary,
                                fontFamily: APP_THEME.fontFamily,
                            }}
                        >
                            v{APP_THEME.appVersion}
                        </span>
                    </Row>
                </Section>

                <AppFooter />
            </div>

            <style>
                {`
                    .transition-all {
                        transition-property: all;
                    }
                    .duration-250 {
                        transition-duration: 250ms;
                    }
                `}
            </style>
        </>
    );
}

export default Setting;